import { cn } from "@/lib/utils";
import { Eye, EyeOff } from "lucide-react";
import * as React from "react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: any;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, type, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <div className="w-full">
        <style>{`
          .brand-input:hover:not(:focus):not(:disabled) {
            border-color: #93d66c !important;
          }
          .brand-input:focus-visible {
            border-color: #4dbd07 !important;
            box-shadow: 0 0 0 4px rgba(77, 189, 7, 0.2) !important;
          }
        `}</style>
        <div className="w-full relative">
          <input
            className={cn(
              "brand-input flex h-11 w-full text-slate-700 rounded-lg border-2 border-input bg-background px-4 py-2 text-sm text-foreground shadow-sm transition-all placeholder:text-muted-foreground/70 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
              type === "search" &&
                "[&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none [&::-webkit-search-results-button]:appearance-none [&::-webkit-search-results-decoration]:appearance-none",
              type === "file" &&
                "p-0 pr-3 italic text-muted-foreground/70 file:me-3 file:h-full file:border-0 file:border-r file:border-solid file:border-input file:bg-transparent file:px-3 file:text-sm file:font-medium file:not-italic file:text-foreground",
              className,
              {
                "border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20":
                  error,
              }
            )}
            ref={ref}
            type={showPassword ? "text" : type}
            {...props}
          />
          {type === "password" && (
            <a
              className="absolute top-1/2 cursor-pointer right-4 transform -translate-y-1/2 text-slate-500 dark:text-slate-300"
              type="button"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <Eye size={16} /> : <EyeOff size={16} />}
            </a>
          )}
        </div>
        {error && (
          <span className="text-red-500 first-letter-uppercase text-sm">
            {error}
          </span>
        )}
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
